<template>
  <div class="comp-message-wrap" :style="{zIndex, paddingRight: scrollBarWidth + 'px'}" ref="messageWrap">
    <transition :name="useEffect ? 'mask' : ''">
      <div class="mask msg-box-mask" @touchmove.prevent @click="opts.shadeClose && close"
           v-show="visible"></div> <!--仅能使用v-show，v-if会导致 ref 未定义-->
    </transition>
    <transition :name="useEffect ? 'message-flex' : ''" @after-leave="bindAfterLeave" @before-enter="bindBeforeEnter">
      <div class="message-flex" v-show="visible"> <!--仅能使用v-show，v-if会导致 ref 未定义-->
        <div class="message-box" :class="['type-' + opts.type]" :style="{width: opts.width}">
          <div class="close" v-if="opts.showClose" @click="close"><span class="iconfont iconchahao"></span></div>
          <!--title-->
          <div class="title fwb" :class="opts.align" v-if="opts.title">{{opts.title}}</div>

          <!--icon-->
          <template v-if="opts.icon">
            <div class="flex-between" style="padding:30px 20px;">
              <div class="svg-icon" style="width:70px;padding-bottom: 0;" :class="opts.align">
                <img v-if="opts.icon == 'error'" :src="require('./svg/msg-box-error.svg')" alt="icon">
                <img v-if="opts.icon == 'warning'" :src="require('./svg/msg-box-warning.svg')" alt="icon">
                <img v-if="opts.icon == 'success'" :src="require('./svg/msg-box-success.svg')" alt="icon">
                <img v-if="opts.icon == 'info'" :src="require('./svg/msg-box-info.svg')" alt="icon">
              </div>
              <div style="flex: 1 1 auto; padding:0; text-align: left;min-height: auto;" :class="opts.align"
                   class="context text-color-9" v-if="opts.message" v-html="opts.message"></div>
            </div>
          </template>

          <template v-else>
            <!--message-->
            <div :class="opts.align" class="context text-color-9" v-if="opts.message" v-html="opts.message"></div>
          </template>

          <div class="box-scroll-content" v-if="$slots.default" :class="{p15: opts.contentPadding}"
               :style="{'max-height': hasFooter ? 'calc(100vh - 150px)' : 'calc(100vh - 90px)'}">
            <slot></slot>
          </div>

          <div class="btns" :class="['is-type-' + opts.type]" v-if="hasFooter">
            <a href="javascript:"
               class="btn btn-sm"
               :class="[opts.cancelButtonClass]"
               @click="bindClick('cancel')"
               v-if="opts.showCancelButton">{{opts.cancelButtonText}}</a>
            <a href="javascript:"
               class="btn btn-sm"
               :class="[opts.confirmButtonClass]"
               @click="bindClick('confirm')"
               v-if="opts.showConfirmButton">{{opts.confirmButtonText}}</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  /**
   * @author shaojingchao
   * @date 2018/12/7
   * @project kaoshizhongxin
   * @desc
   */
  import { defaultCfg, typeCfg } from './default-cfg'
  import { getScrollbarWidth } from '../../utils/scrollbar-width'

  let zIndex = defaultCfg.zIndex
  export default {
    name: 'comp-message',
    props: {
      useEffect: {
        type: Boolean,
        default: true
      },
      options: {
        type: Object,
        default () {
          return defaultCfg
        }
      }
    },
    data () {
      return {
        opts: {},
        zIndex: -1,
        visible: false,
        showMask: true,
        scrollBarWidth: 0
      }
    },
    computed: {
      hasFooter () {
        return (this.opts.showCancelButton || this.opts.showConfirmButton)
      }
    },
    created () {
      // 全局组方式调用
      Object.assign(this.opts, defaultCfg, this.options, typeCfg[this.options.type || 'msg'])
    },
    mounted () {
      if (this.opts.appendToBody) {
        document.body.appendChild(this.$el)
      }
      this.scrollBarWidth = getScrollbarWidth()
    },
    beforeDestroy () {
      // bugfix 修复返回当前页面后，页面无法滚动问题
      this.bindAfterLeave()
      this.removeDom(this.$el)
    },
    methods: {
      removeDom (wrap) {
        if (wrap.parentNode) {
          wrap.parentNode.removeChild(wrap)
          if (this.$_remove) this.$_remove()
        }
      },
      open () {
        this.visible = true
        this.$emit('open')
      },
      close (type = 'cancel') {
        this.visible = false
        this.$emit('close', type)
      },
      bindClick (type) {
        let opts = this.opts
        // 回调方式关闭弹框
        if (opts.callbackClose && opts.callback) {
          if (type === 'cancel') {
            this.close(type)
          }
          opts.callback(type, this.close)
        } else if (opts.callback) { // 否则直接关闭
          this.close(type)
          opts.callback(type)
        } else {
          this.close(type)
        }
      },
      bindBeforeEnter () {
        this.zIndex = zIndex++
        $('body').css({ overflowY: 'hidden', paddingRight: this.scrollBarWidth })
      },
      bindAfterLeave () {
        this.zIndex = -1
        if ($('.msg-box-mask:visible').length === 0) {
          $('body').css({ overflowY: 'scroll', paddingRight: 0 })
        }
      }
    }
  }
</script>

<style lang="less">
  @import '../../styles/_mixins-wln';

  @border-radius: 3px;
  .comp-message-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;

    .box-scroll-content {
      overflow-y: auto;
    }

    .mask {
      top: 0;
      left: 0;
      position: fixed;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .65);
      z-index: 1000;

      &-enter, &-leave-to {
        opacity: 0;
      }

      &-enter-active {
        transition: opacity .25s;
      }

      /*&-leave-active {*/
      /*  transition: opacity .3s 0.2s;*/
      /*}*/
    }

    .message-flex {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 1001;

      &-enter {
        opacity: 0;
        transform: translate3d(0, -10px, 0);
      }

      /*&-leave-to {*/
      /*  opacity: 0;*/
      /*  transform: translate3d(0, -100%, 0);*/
      /*}*/

      &-enter-active {
        animation: message-flex 0.25s;
        /*transition: transform .25s, opacity .2s;*/
      }

      /*&-leave-active {*/
      /*  transition: transform .3s, opacity .3s;*/
      /*}*/
    }

    @keyframes message-flex {
      0% {
        opacity: 0;
        transform: scale3d(0.3, 0.3, 0.3);
      }

      60% {
        transform: scale3d(1.01, 1.01, 1.01);
      }

      100% {
        opacity: 1;
        transform: scale3d(1, 1, 1);
      }
    }

    .message-box {
      /*padding: 0 0 20px;*/
      border-radius: @border-radius;
      background: #ffffff;
      box-sizing: border-box;
      max-width: 1400px;
      min-width: 400px;
      position: relative;
      overflow: hidden;
      box-shadow: 0 15px 50px rgba(0, 0, 1, .35);

      &.type-alert, &.type-confirm {
        padding-bottom: 35px;

        .context {
          padding: 35px;
        }
      }

      .title {
        /*background-color: rgba(250,250,250,1);*/
        line-height: 50px;
        font-size: 17px;
        /*margin:0 -15px;*/
        border-bottom: 1px solid #f5f5f5;
        padding: 0 15px;
      }

      .close {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 14px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #ccc;
        cursor: pointer;
        /*&:hover {*/
        /*  background-color: #fafafa;*/
        /*}*/
      }

      .svg-icon {
        flex: 0 0 auto;
        padding-bottom: 10px;

        img {
          width: 50px;
          height: 50px;
          display: block;
          margin: 0 auto;
        }
      }

      .context {
        line-height: 1.5;
        min-height: 35px;
        padding-top: 15px;
        padding-bottom: 15px;
      }

      .btns {
        display: flex;
        justify-content: center;

        &.is-type-custom {
          padding: 15px;
          border-top: 1px solid #f5f5f5;
        }

        /*&.is-type-custom {*/
        /*  padding:15px;*/
        /*  border-top: 1px solid #f5f5f5;*/
        /*}*/

        .btn {
          /*flex: 1 1 auto;*/
          box-sizing: border-box;
          padding: 0.5em;
          font-size: 14px;
          min-width: 110px;
          margin-left: 15px;

          &:first-child {
            margin-left: 0;
          }

          cursor: pointer;
        }

        &-plain {
          overflow: hidden;
          /*border-top:1px solid #ddd;*/
          margin: 0 -15px;

          .btn-plain {
            border: none;
            background-color: #fff;
            flex: 1 1 auto;
            box-sizing: border-box;
            padding: 0.8em 0;
            text-align: center;
            font-size: 15px;
            color: @primary;
            border-radius: 0 0 @border-radius @border-radius;
            /*border-left:1px solid #ddd;*/

            &:first-child {
              border-left: none;
            }
          }
        }
      }
    }
  }
</style>
